<template>
</template>
<script>
export default {
    created(){
        let check = this.$route.query;
        window.open(check.url, '_blank')
    }
}
</script>